import createContextStore from '@src/contexts/contextStore';
import React from 'react';
import { SCOPE } from './types';
import reducer, { initialState } from './reducer';
import actions from './actions';
import sagas from './sagas';

const { useStore, StoreProvider } = createContextStore({
  defaultValue: initialState,
  displayName: SCOPE,
});

function ViewerProvider({ initValues = {}, children }) {
  return (
    <StoreProvider reducer={reducer} initialState={{ ...initialState, ...initValues }}>
      {children}
    </StoreProvider>
  );
}

export { useStore as useViewerStore, ViewerProvider, actions, sagas, reducer };
